/**
 * Initial state factory for the "analytics" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. Currently empty — the module
 * only exposes actions (see operations.js) that report metrics directly to
 * the API without keeping local state.
 */
export default () => ({

});
